module.exports = __webpack_public_path__ + "static/image-f1558b7a52a8b1532fc5fb7e6539e1a2.jpg";